import { AlertTitle } from "@chakra-ui/alert";
import { AlertDescription } from "@chakra-ui/alert";
import { AlertIcon } from "@chakra-ui/alert";
import { Alert } from "@chakra-ui/alert";
import { CloseButton } from "@chakra-ui/close-button";
import { Link } from "@chakra-ui/layout";
import { Box } from "@chakra-ui/layout";
import { Link as ReachLink } from "@reach/router";
import { useEffect, useState } from "react";
import { createStandaloneToast } from "@chakra-ui/react";

function InfoBanner({ id = "info-banner" }) {
  const [keepHidden, setKeepHidden] = useState(
    // localstorage can only store strings, this is a workaround
    sessionStorage.getItem("keepHidden") === "true" || false
  );

  useEffect(() => {
    sessionStorage.setItem("keepHidden", keepHidden);
  }, [keepHidden]);

  const toast = createStandaloneToast();

  useEffect(() => {
    const isDemo = JSON.parse(sessionStorage.getItem("isDemo"));

    if (!toast.isActive(id) && !keepHidden && isDemo) {
      toast({
        id,
        position: "bottom-left",
        title: "This is a demo",
        render: ({ onClose }) => (
          <Alert
            status="info"
            variant="subtle"
            backgroundColor="rgba(33, 203, 255, 10%)"
            border="3px dashed rgba(33, 203, 255, 10%)"
            borderRadius="xl"
            maxW={500}
            boxShadow="base"
            width={{ sm: "80%", md: "100%" }}
            mb="10"
            hidden={keepHidden}
          >
            <AlertIcon />
            <Box flex="1">
              <AlertTitle>This is a demo</AlertTitle>
              <AlertDescription whiteSpace={{ md: "nowrap" }}>
                Want to see your own data? Check out{" "}
                <Link as={ReachLink} to="/guide" borderBottom="1px solid" _hover="none">
                  how to get started
                </Link>{" "}
                🚀
              </AlertDescription>
            </Box>
            <CloseButton
              position="absolute"
              right="8px"
              top="8px"
              onClick={() => onClose(setKeepHidden(true))}
            />
          </Alert>
        ),
        status: "info",
        duration: null,
        isClosable: true,
      });
    }

    return () => {
      toast.close(id);
    };
    // eslint-disable-next-line
  }, []);

  return null;
}

export default InfoBanner;
